import { required, minLength } from 'vuelidate/lib/validators';
import { forcePasswordPolicy } from '@/app/utils/validations/validations';

export default {
  name: 'new-password',
  data: () => ({
    form: {
      password: '',
    },
  }),
  methods: {
    async setPassword() {
      this.$v.form.$touch();
      if (!this.$v.form.$anyError) {
        await this.$store.dispatch('auth/setPassword', { newPassword: this.form.password });
        if (this.$store.getters['auth/loggedIn']) {
          this.$router.push('/account/details');
        } else if (this.$store.getters['auth/hasAction']) {
          if (this.$store.state.auth.action.challengeName === 'EMAIL_VERIFICATION_REQUIRED') {
            this.$router.push('/auth/confirm-email');
          } else {
            this.$router.push('/auth/sign-in');
          }
        } else {
          this.$router.push('/auth/sign-in');
        }
      }
    },
  },
  validations: {
    form: {
      password: {
        required,
        minLength: minLength(8),
        forcePasswordPolicy,
      },
    },
  },
};
